import { Kbd, Loader } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Tags } from "@/components/utils"
import { useAPIResources } from "@/hooks"
import { tagsAPI } from "@/utils"
import { getChoicesByBinaryMask } from "../../questions/utils"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

export function AnswerTags({ answer, question }: IAnswerProps) {
  const { t } = useTranslation("tags")
  const {
    meta: { category },
  } = question
  const { data: { data } = {}, isLoading } = useAPIResources(tagsAPI, {
    where: { category },
    enabled: !!answer?.value,
  })

  if (!answer?.value) return <NoAnswer />
  if (isLoading) return <Loader size="xs" />
  if (!data) return <NoAnswer />

  const choices = getChoicesByBinaryMask(answer?.value || 0)

  return (
    <Tags>
      {choices.map((choice) => {
        const tag = data[choice]
        if (!tag) return null

        return (
          <Kbd size="sm" key={choice}>
            {t(tag.id)}
          </Kbd>
        )
      })}
    </Tags>
  )
}
